import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const REGISTER_URL = "https://app.contaariadigital.com.br/register";

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
};

const SLIDES = [
  {
    image: "/img/3slide.jpg",
    title: "ÁRIA - A Liberdade de Fazer Mais com Seu Dinheiro",
    subtitle:
      "Transforme sua vida financeira com soluções flexíveis, rápidas e seguras. Seja você, sem limitações, com ÁRIA",
  },
  {
    image: "/img/bank-metta.webp",
    title: "Banco Ária a tecnologia é nossa o LUCRO é seu!",
    subtitle: "",
  },
  {
    image: "/img/header.webp",
    title: "Garantias",
    subtitle:
      "Garantias personalizadas ajudarão você em cada fase da sua vida!",
  },
];

// Função utilitária para abrir URL em nova aba
const openInNewTab = () => {
  window.open(REGISTER_URL, "_blank", "noreferrer");
};

// Componente separado para cada slide
const SlideItem = ({ slide }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <img
        src={slide.image}
        alt={slide.title}
        loading="lazy"
        className="slide-img"
      />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-xs-12 intro-text">
              <h1 className="upp">{slide.title}</h1>
              <p className="subtitle m-top m-bottom">{slide.subtitle}</p>
              <button className="btn btn-custom btn-lg" onClick={openInNewTab}>
                Abra sua conta
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Componente principal
export const Slidershow = () => (
  <div className="slideshow">
    <Slider {...SLIDER_SETTINGS}>
      {SLIDES.map((slide, index) => (
        <SlideItem key={index} slide={slide} />
      ))}
    </Slider>
  </div>
);
